module.exports = __webpack_public_path__ + "img/batchQr.fbfc27c5.jpg";